<template>
  <v-card class="w-full pa-2 mb-4">
    <div class="d-flex flex-row justify-between" style="place-items: center;">
      <div>
        <span class="f-bold f-s-xs" style="color: #000;">{{ itemFF.fare_name }}</span>
      </div>
      <div class="d-flex flex-column" style="font-size: x-small;">
        <span>{{ $t("PurchaseDate") }}</span>
        <span>{{ itemFF.success_time }}</span>
      </div>
    </div>
    <hr />

    <div class="d-flex flex-row justify-between">
      <timeline-dashed :route="timelineDashed"/>
    </div>
    <hr />
    
    <div class="d-flex flex-row justify-between">
      <div class="d-flex flex-column self-center" style="line-height: 1;">
        <span class="f-bold f-s-xs">{{ $t("TicketStatus") }}:</span>
        <span v-if="isExpired" style="font-size: 11px;">{{ $t("Expired") }}</span>
        <span v-else style="font-size: 11px;">{{ $t("TicketNotYetUsed") }}</span>
      </div>
      <div style="justify-items: flex-end;">
        <v-col class="d-flex justify-center pa-0">
          <div style="height: 40px; align-content: center;">
            <ac-button 
              :small="true"
              :name="$t('ViewTicket')" 
              :on-click-handler="clickView"
              :width="'100px'"
              :height="'35px'"
              :color="$partnerACL.getButtonColor()"
              class="btn-view-ticket"
            />
          </div>
        </v-col>
      </div>
    </div>
    
    <div v-if="typeof itemFF.ticket_id != 'string'">
      <hr />
      <span class="f-s-xs">{{ $t("TotalBundling") }} : {{ itemFF.ticket_id.length }} {{ $t("Person") }}</span>
    </div>
  </v-card>
</template>

<script>
import TimelineDashed from "@/components/TimelineDashed.vue";
import AcButton from "@/components/AcButton";
import moment from "moment"

export default {
  name: "CardTicketSingleTrip",
  components: {
    TimelineDashed,
    AcButton
  },
  props: {
    itemFF: {
      type: Object
    },
    tickettransaction: {
      type: String,
      default: "Ticket Transaction",
    },
    orig: {
      type: String,
      default: "BTH",
    },
    original: {
      type: String,
      default: "Bến Thành",
    },
    expticket: {
      type: String,
      default: "Single Trip ticket is valid until 24 hours",
    },
    routename: {
      type: String,
      default: "Route 3",
    },
    flatefare: {
      type: String,
      default: "Single Trip",
    },
    dest: {
      type: String,
      default: "TLC",
    },
    destination: {
      type: String,
      default: "Thạnh Lộc",
    },
    viewticket: {
      type: String,
      default: "ViewTicket",
    },
    routeInformation: {
      type: Object
    },
  },
  async created() {
    const payloadCurrency = {
      currencyCode: localStorage.getItem('currency') || "IDR",
    };
    await this.$store.dispatch("purchaseticket/getCurrencyConversionRate", payloadCurrency)
  },
  computed: {
    provider() {
      return this.$store.state.auth.provider
    },
    timelineDashed() {
      try {
        const length = this.itemFF.fare_detail[0].trip_route_by_code.length
        return {
          origin: this.itemFF.fare_detail[0].trip_route_by_code[0],
          long_origin: this.itemFF.fare_detail[0].trip_route[0],
          destination: this.itemFF.fare_detail[0].trip_route_by_code[length - 1],
          long_destination: this.itemFF.fare_detail[0].trip_route[length - 1]
        }
      } catch (error) {
        console.log(error)
        return {
          origin: "",
          long_origin: "",
          destination: "",
          long_destination: ""
        }
      }
    },
    expiredTicket() {
      const DEFAULT_TIME = '23:59:59';
      const now = moment();
      const { fare_rule, invoice_detail, valid_days, expired_on_same_day } = this.itemFF
      const { validate_close_date, validate_close_time } = fare_rule

      const closeDate = validate_close_date ? moment(validate_close_date) : null;
      const closeTime = validate_close_time || DEFAULT_TIME;
      const createdDate = moment(invoice_detail[0].payment_success_time);
      const validDaysMoment = moment(now).add(valid_days, 'days');

      if (expired_on_same_day) {
        return moment.utc(createdDate.format('YYYY-MM-DD') + ' ' + DEFAULT_TIME)
      }

      if (closeDate != null) {
        return moment.utc(closeDate.format('YYYY-MM-DD') + ' ' + closeTime)
      } else if (closeDate == null) {
        return "Unlimited"
      }

      // format close datetime
      const fullCloseDate = closeDate
        ? moment(closeDate.format('YYYY-MM-DD') + ' ' + closeTime)
        : null;

      // 1. jika current > closeDate
      if (fullCloseDate && validDaysMoment.isAfter(fullCloseDate)) {
        return moment.utc(fullCloseDate)
      }

      // 2. jika current < closeDate
      if (fullCloseDate && validDaysMoment.isBefore(fullCloseDate)) {
        return moment(validDaysMoment.format('YYYY-MM-DD') + ' ' + closeTime)
      }

      // fallback: createdDate + validDays + default time
      return moment.utc(createdDate).add(valid_days, 'days').set({
        hour: 23,
        minute: 59,
        second: 59
      })
    },
    formattedExpTicket() {
      if (this.expiredTicket === "Unlimited") return "Unlimited"
      return this.expiredTicket.format("DD-MM-YYYY | HH:mm");
    },
    isExpired() {
      if (this.expiredTicket === "Unlimited") return false
      return moment().isAfter(moment(this.expiredTicket))
    }
  },
  methods: {
    clickRouteInformation() {
      this.$store.commit("moduleUi/ROUTE_INFORMATION", this.routeInformation);
    },
    clickView() {
      if (this.provider == 'GOBUS') {
        this.$router.push({
          name: "GobusDetailTicket",
          params: {
            data: this.itemFF,
          },
        });
      } else {
        const fareType = this.itemFF.fare_type
        const detailButton = this.$partnerACL.getMetaButton('detail');
        if (detailButton) {
          if (detailButton.menu_type == "wsc_menu") {
            let data = this.itemFF
            if (detailButton.redirect_name === "ShowQR") {
              data = this.itemFF.ticket_id
            }
            this.$router.push({
              name: detailButton.redirect_name,
              params: {
                data,
                detail: this.itemFF,
                expired_ticket: this.formattedExpTicket,
                method: (fareType == 7 || fareType == 8) ? "all": "" ,
                is_expired: this.isExpired
              },
            });
          } else {
            window.location = detailButton.redirect_path;
          }
        } else {
          this.$router.push({
            name: "ViewTicket",
            params: {
              data: this.itemFF,
            },
          });
        }
      }
    },
    convertPriceByCurrency(price, currency) {
      const conversionRates = this.$store.state.purchaseticket.currency ? this.$store.state.purchaseticket.currency.conversionRates : null;
      const priceResult = price * conversionRates[currency];
      return priceResult;
    },
  },
};
</script>

<style lang="scss" scoped>
hr {
  border: none;
  height: 1px;
  background-color: #ccc;
  margin: 4px 0;
}

.btn-view-ticket {
  font-size: 14px;
}
</style>